import React from 'react';
import '../../FormBuilder.css';

const VideoElement = ({ component, isRequired }) => {
  const renderElement = () => {
    return (
      component.elementName === 'video' && (
        <label className='titleTextLbl'>
            {component.fieldName || "Video"}
            <span className='requiredContainer' style={{ color: 'red' }}>{isRequired(component)}</span>
        </label>
      )
    );
  };

  return (
    <div className='renderAllElements'>
      {renderElement()}
    </div>
  );
};

export default VideoElement;
